import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Clock, User } from 'lucide-react';

const BlogPage = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'Building NebiusFlow: A Journey into Modern Web Development',
      excerpt: 'Learn how we built NebiusFlow using React, Cloudflare Workers, and modern serverless architecture...',
      author: 'Damiete',
      date: '2025-09-20',
      readTime: '5 min read',
      category: 'Technical'
    },
    {
      id: 2,
      title: '10 Productivity Tips for Remote Workers',
      excerpt: 'Discover proven strategies to boost your productivity while working from home...',
      author: 'NebiusFlow Team',
      date: '2025-09-18',
      readTime: '3 min read',
      category: 'Productivity'
    },
    {
      id: 3,
      title: 'The Future of Task Management: AI and Automation',
      excerpt: 'Explore how artificial intelligence is revolutionizing the way we manage our daily tasks...',
      author: 'Damiete',
      date: '2025-09-15',
      readTime: '7 min read',
      category: 'Innovation'
    },
    {
      id: 4,
      title: 'Why We Chose Cloudflare for NebiusFlow',
      excerpt: 'A deep dive into our decision to build on Cloudflare\'s edge network and the benefits it brings...',
      author: 'Engineering Team',
      date: '2025-09-12',
      readTime: '6 min read',
      category: 'Technical'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-white">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center text-primary-600 hover:text-primary-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">NebiusFlow Blog</h1>
          <p className="text-xl text-gray-600 mb-12">
            Insights, updates, and tips from the NebiusFlow team
          </p>

          <div className="grid md:grid-cols-2 gap-8">
            {blogPosts.map((post, index) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className="px-3 py-1 bg-primary-100 text-primary-700 text-sm rounded-full">
                    {post.category}
                  </span>
                  <span className="text-sm text-gray-500 flex items-center">
                    <Clock className="w-4 h-4 mr-1" />
                    {post.readTime}
                  </span>
                </div>
                
                <h2 className="text-2xl font-semibold mb-3 text-gray-900">
                  {post.title}
                </h2>
                
                <p className="text-gray-600 mb-4">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center">
                    <User className="w-4 h-4 mr-1" />
                    {post.author}
                  </div>
                  <div className="flex items-center">
                    <Calendar className="w-4 h-4 mr-1" />
                    {new Date(post.date).toLocaleDateString()}
                  </div>
                </div>
                
                <button className="mt-4 text-primary-600 hover:text-primary-700 font-medium">
                  Read more →
                </button>
              </motion.article>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600">
              More articles coming soon! Follow us for updates on productivity, technology, and NebiusFlow features.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default BlogPage;
